<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    v-bind="attrs"
    v-on="$listeners"
    :fullscreen="isMobile"
    scrollable
  >
    <v-card>
      <div v-if="$slots.header" class="header">
        <v-card-title class="primary--text pa-4">
          <slot name="header"></slot>
        </v-card-title>
        <v-divider v-if="dividers" />
      </div>
      <v-card-text class="pa-0">
        <slot />
      </v-card-text>
      <div v-if="$slots.footer" class="footer">
        <v-divider v-if="dividers" />
        <v-card-actions class="pa-4">
          <slot name="footer" />
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'popup',
  props: {
    value: {
      type: [Boolean],
      default: false
    },
    dividers: {
      type: [Boolean],
      default: true
    }
  },
  computed: {
    attrs() {
      const attrs = this.$attrs;
      const { value, input } = attrs;
      return attrs;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  }
};
</script>

<style lang="sass" scoped>
.popup-base-card
  padding: 0 8px
</style>
